import React, { useRef, useState } from 'react';
import './take-attendance-by-one.scss';

import Icon from '../icon/icon';
import { Box, Button, CircularProgress, Drawer, Input } from '@mui/material';
import { useMutation, useQuery } from '@apollo/client';
import Message from '../message/message';
import { ATTENDANCE_TAKED, RESERVES_BY_CALENDAR } from '../../graphql/branch';
import { MESSAGE_DEFAULT } from '../../../class-branch/constants/messages';

function TakeAttendanceByOne({ calendarId, isOpenModal, setIsOpen }: any) {

    let message = MESSAGE_DEFAULT;
    message.open = useRef<any>(null);

    const [isOpen, setOpen] = useState(isOpenModal);
    const [textValue, setTextValue] = useState('');

    const toggleDrawer = () => {
        setOpen((prevIsOpen: any) => !prevIsOpen); // Invierte el valor de isOpen
        setIsOpen((prevIsOpen: any) => !prevIsOpen); // Invierte el valor de isOpen en el componente principal
    };

    const onTextChange = (e: any) => (setTextValue(e));

    const { data } = useQuery(RESERVES_BY_CALENDAR, {
        variables: { calendarId: calendarId },
    });
    let reservesData = data ? data.reservationsByCalendar : [];


    const [takeAttendanceMutation, { loading, reset }] = useMutation(ATTENDANCE_TAKED, {
        refetchQueries: [RESERVES_BY_CALENDAR]
    });
    if (loading) return <CircularProgress size={25} />;

    const takeAttendance = async (event: any, reserveId: string | number, btn: boolean = false) => {       
        if (event?.key !== 'Enter' && !btn) return;

        let identification = event.target.value;
        if (!identification) return;

        await takeAttendanceMutation({
            variables: {
                bookId: reserveId,
                idCardUser: identification.toString(),
                originWeb: true,
            },
        }).then((response: any) => {

            if (response.data && response.data.attendanceClassStudio) {
                message.textMessage = response.data.attendanceClassStudio.message;
                message.style = response.data.attendanceClassStudio.success ? 'success' : 'danger';
                setTimeout(() => {
                    message.open.current.show();
                }, 500);
                reset();
            };

        }).catch((error) => {
            console.error(error)
        });
    }

    const statusText = (virtual: boolean, status: number) => {
        if (virtual && (status === 1 || status === 7)) {
            return 'Reservada';
        } else if (status === 2) {
            return 'Tomada';
        } else if (status === 5) {
            return 'Cancelado';
        } else if (status === 3) {
            return 'Cancelado tarde';
        } else if (status === 4) {
            return 'No show';
        }
        return <></>
    }

    return (
        <div>
            <Drawer anchor='right' open={isOpen} onClose={toggleDrawer}
                sx={{
                    width: '27%',
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: '27%',
                    },
                }}
                className='modal-take-attendance-by-one'>
                <div>
                    <Button className='btn-back' onClick={toggleDrawer}>
                        <Icon name='back' width='22' height='22' color='#757575' />
                        <span>Volver</span>
                    </Button>
                    <div className='body-take-attendance-by-one'>
                        <h2 className='title-take-attendance'>Asistencia</h2>
                        <small>({reservesData.length} usuarios)</small>
                        <ul className='list-users-take-attendance'>
                            {reservesData.map((user: any, index: number) => (
                                <li key={index}>
                                    <p className='user-name'>{`${user.user.names} ${user?.user.surnames}`}</p>
                                    { (user?.status?.id === 1 || user?.status?.id === 13) ? (
                                        <Box className="contain-input">
                                            <Input className='input-take-attendance' placeholder='Cédula de ciudadanía'
                                                onKeyUp={(event: any) => (takeAttendance(event, user?.id))} onChange={(ev) => onTextChange(ev)} />
                                            <Icon name="check" width='18' height='18' cursor='pointer' buttonClick={() => (takeAttendance(textValue, user?.id, true))} />
                                        </Box>
                                    ) :
                                        statusText(user?.calendar?.classFit.virtual, user?.status?.id)
                                    }
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Drawer>

            <Message data={message} ref={message.open} />
        </div>
    );
}

export default TakeAttendanceByOne;
